import { render, staticRenderFns } from "./TransferenciasPage.vue?vue&type=template&id=13bd350e&scoped=true"
import script from "./TransferenciasPage.vue?vue&type=script&lang=ts"
export * from "./TransferenciasPage.vue?vue&type=script&lang=ts"
import style0 from "./TransferenciasPage.vue?vue&type=style&index=0&id=13bd350e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bd350e",
  null
  
)

export default component.exports